import Box from '@mui/material/Box'
import styled from '@emotion/styled'
import { useRouter } from 'next/router'

import { maxContentWidth, indexPageMaxContentWidth } from 'config/theme'

const StyledContentWrapper = styled(Box)`
  ${({ theme, $xs, $lg, $xl, $xxl, $widthLimit, $isHomePage }) => `
    width: 100%;
    max-width: ${
      $widthLimit
        ? $isHomePage
          ? indexPageMaxContentWidth
          : maxContentWidth
        : 'none'
    };
    margin-left: auto;
    margin-right: auto;

    padding-left: ${theme.spacing($xs ? 4 : 0)};
    padding-right: ${theme.spacing($xs ? 4 : 0)};

    ${
      $isHomePage
        ? `
        padding-left: ${theme.spacing($xs ? 4 : 0)};
        padding-right: ${theme.spacing($xs ? 4 : 0)};

        ${theme.breakpoints.up('md')} {
          padding-left: ${theme.spacing(8)};
          padding-right: ${theme.spacing(8)};
        }

        ${theme.breakpoints.up('xl')} {
          padding-left: ${theme.spacing($xl ? 12 : 0)};
          padding-right: ${theme.spacing($xl ? 12 : 0)};
        }
      `
        : `
        ${theme.breakpoints.up('lg')} {
          padding-left: ${theme.spacing($lg ? 9 : 0)};
          padding-right: ${theme.spacing($lg ? 9 : 0)};
        }

        ${theme.breakpoints.up('xl')} {
          padding-left: ${theme.spacing($xl ? 12 : 0)};
          padding-right: ${theme.spacing($xl ? 12 : 0)};
        }

        ${theme.breakpoints.up('xxl')} {
          padding-left: ${theme.spacing($xxl ? 16 : 0)};
          padding-right: ${theme.spacing($xxl ? 16 : 0)};
        }
      `
    }
  `}
`

const ContentWrapper = (props) => {
  const router = useRouter()
  const isHomePage = router.pathname === '/'

  return <StyledContentWrapper $isHomePage={isHomePage} {...props} />
}

ContentWrapper.defaultProps = {
  $xs: true,
  $lg: true,
  $xl: true,
  $xxl: true,
  $widthLimit: true,
  $isHomePage: false,
}

export default ContentWrapper

export const MaxWidthWrapper = styled(Box)`
  width: 100%;
  max-width: ${maxContentWidth};
  margin-left: auto;
  margin-right: auto;
`
